module.exports = __webpack_public_path__ + "static/images/ico-fillblank@2x.858543a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/ico-fillblank@2x.png
// module id = 96pM
// module chunks = 6 7